import { render, staticRenderFns } from "./ProtectedPlanetArgentina.vue?vue&type=template&id=1e979293&scoped=true&lang=pug"
import script from "./ProtectedPlanetArgentina.vue?vue&type=script&lang=js"
export * from "./ProtectedPlanetArgentina.vue?vue&type=script&lang=js"
import style0 from "./ProtectedPlanetArgentina.vue?vue&type=style&index=0&id=1e979293&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e979293",
  null
  
)

export default component.exports